import { registerMutation, useMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
const UPDATE_FORM_SUBSCRIPTIONS_FIELD_NAME = 'UPDATE_COLLECTED_FORMS_NAME';
const UPDATE_FORM_SUBSCRIPTIONS = registerMutation({
  fieldName: UPDATE_FORM_SUBSCRIPTIONS_FIELD_NAME,
  args: ['formGuid', 'subscriptions'],
  fetcher({
    formGuid,
    subscriptions
  }) {
    return http.put(`/esp-sync/v1/form-subscriptions/${formGuid}`, {
      data: subscriptions
    });
  }
});
export default function useUpdateSubscriptions() {
  const [updateSubscriptions, {
    loading,
    error
  }] = useMutation(UPDATE_FORM_SUBSCRIPTIONS);
  return {
    error,
    loading,
    updateSubscriptions: variables => updateSubscriptions({
      variables
    })
  };
}